import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getDepositorWiresPath = () => urlHelper('/depositor/wires');
